import { z } from 'zod';

export const NotificationSettings = z.object({
  morningDigest: z.boolean(),
  gameReminders: z.boolean(),
  meetingOffers: z.boolean(),
});
export type NotificationSettings = z.infer<typeof NotificationSettings>;

export const UpdateNotificationSettingsInput = z
  .object({
    morningDigest: z.boolean().optional(),
    gameReminders: z.boolean().optional(),
    meetingOffers: z.boolean().optional(),
  })
  .refine(
    (v) => v.morningDigest !== undefined || v.gameReminders !== undefined || v.meetingOffers !== undefined,
    { message: 'at least one field required' },
  );
export type UpdateNotificationSettingsInput = z.infer<typeof UpdateNotificationSettingsInput>;
